// @flow
import type { Props } from './index';
import {
  CheckCircleFilledIcon,
  NotStartedIcon,
} from '@fortress-technology-solutions/fortress-component-library/Icons';

export const determineIcon = (variant: Props['variant']) => {
  switch (variant) {
    case 'notStarted':
      return NotStartedIcon;
    case 'completed':
      return CheckCircleFilledIcon;
    case 'submitted':
      return CheckCircleFilledIcon;
    default:
      return CheckCircleFilledIcon;
  }
};
